import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { ExportDialogModule } from '@core/components/export-dialog/export-dialog.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule } from '@fuse/components/sidebar/sidebar.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { WarrantyStatusBadgeModule } from '../../core/components/warranty-status-badge/warranty-status-badge.module';

import { DirectivesModule } from '@core/directives/directives.module';
import { DialogEquipmentsModule } from './dialog/dialog-equipments.module';
import { EquipmentsComponent } from './equipments.component';
import { FilterEquipmentsModule } from './filter/filter-equipments.module';
import { EquipmentsAttachmentsApi } from './services/api/equipments-attachments.api';
import { EquipmentsApi } from './services/api/equipments.api';
import { EquipmentsService } from './services/equipments-resolver.service';

const routes: Routes = [
  {
    path: 'equipamentos',
    component: EquipmentsComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.EQUIPMENTS.TITLE' }
  }
];

@NgModule({
  declarations: [
    EquipmentsComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    FilterEquipmentsModule,
    DialogEquipmentsModule,
    ExportDialogModule,
    WarrantyStatusBadgeModule,
    DirectivesModule
  ],
  exports: [
    EquipmentsComponent
  ],
  providers: [
    EquipmentsApi,
    EquipmentsAttachmentsApi,
    EquipmentsService
  ]
})

export class EquipmentsModule { }
